import gql from 'graphql-tag'
import { EntityFields } from '..'

export const ComponentCategoryFragment = gql`
  fragment ComponentCategory on vehicle_component_category {
    ${EntityFields}
    name
  }
`
